import * as THREE from 'three';
import { getSnappedPoint } from '../../../shared/snap/getSnappedPoint';
import { createSnapMarker } from '../../../shared/snap/createSnapMarker';

// Ortho hizalama
export const getOrthoSnappedPoint = (center, current) => {
    const dx = Math.abs(current.x - center.x);
    const dy = Math.abs(current.y - center.y);
    if (dx > dy) {
        return new THREE.Vector3(current.x, center.y, 0); // yatay
    } else {
        return new THREE.Vector3(center.x, current.y, 0); // dikey
    }
};

// Snap a point to the grid.
// Default step = 5 — matches the project-wide "duvar ile tesisat çizgisi arası
// mesafe" (wall-to-installation-line offset used by the magenta/cyan guide
// lines in snapWallHandler). Callers can pass a custom gridSize if needed.
export const applyGridSnap = (point, gridSize = 5) => {
    return new THREE.Vector3(
        Math.round(point.x / gridSize) * gridSize,
        Math.round(point.y / gridSize) * gridSize,
        0
    );
};

// Snap a point relative to a reference (start vertex) — so from the start
// point, only multiples of `gridSize` away are reachable. Used while drawing
// wires: mouse moves freely but final point lands at startVertex + n·step.
export const applyRelativeGridSnap = (point, reference, gridSize = 5) => {
    if (!reference) return applyGridSnap(point, gridSize);
    const dx = Math.round((point.x - reference.x) / gridSize) * gridSize;
    const dy = Math.round((point.y - reference.y) / gridSize) * gridSize;
    return new THREE.Vector3(reference.x + dx, reference.y + dy, 0);
};

// Shared click handler for drawing operations
export const createDrawingClickHandler = (options) => {
    const {
        scene,
        camera,
        renderer,
        snapPoints,
        snapMarkerRef,
        gridMode,
        objectSnap,
        snapMode,
        onPointSelected
    } = options;

    return (e) => {
        const domElement = renderer.domElement;
        const rect = domElement.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        const y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
        const mouseNDC = new THREE.Vector2(x, y);
        const worldPoint = new THREE.Vector3(x, y, 0).unproject(camera);

        const { finalPoint, snapped, snapSource } = getSnappedPoint(
            mouseNDC,
            worldPoint,
            snapPoints,
            camera,
            renderer,
            { snapMode }
        );

        const point = snapped ? finalPoint.clone() : (gridMode ? applyGridSnap(worldPoint) : worldPoint.clone());

        // Clean up previous snap marker
        if (snapMarkerRef.current) {
            scene.remove(snapMarkerRef.current);
            snapMarkerRef.current.geometry.dispose();
            snapMarkerRef.current.material.dispose();
            snapMarkerRef.current = null;
        }

        // Create new snap marker if snapped
        if (snapped && snapSource) {
            const marker = createSnapMarker(8, snapSource);
            marker.position.copy(finalPoint);
            scene.add(marker);
            snapMarkerRef.current = marker;
        }

        // Call the specific drawing logic
        onPointSelected(point, { snapped, snapSource, finalPoint });
    };
};
